import { render, staticRenderFns } from "./NextOneMonthFootfall.vue?vue&type=template&id=ea61f490&"
import script from "./NextOneMonthFootfall.vue?vue&type=script&lang=js&"
export * from "./NextOneMonthFootfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports